/* eslint-disable max-len */
import { organizationusersList } from "./apiSlice";

const patientList = organizationusersList.injectEndpoints({
    tagTypes: ['Patient', 'SelectedSubdivPatient', 'PatientMonitorUser', 'PatientActivityHistory', 'Providers', 'OrganizationList',],
    endpoints: (builder) => ({
        getPatients: builder.query({
            query: (searchParams) => `providers/list-associated-patients?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [

                'Providers',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'Providers', id: _id }))
            ] : []


        }),

        addPatient: builder.mutation({
            query: org => ({
                url: `/patients/`,
                method: 'POST',
                body: org
            }),
            invalidatesTags: ['Patient']
        }),
        getPatientSubdivisions: builder.query({
            query: (searchParams) => `organizations/list-subdivisions?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [

                'SelectedSubdivPatient',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'SelectedOrg', id: _id }))
            ] : [],
        }),

        getPatient: builder.query({
            query: (id) => `/patients/${id}`,
            providesTags: (result, error, arg) => [{ type: 'Patient', id: arg }]
        }),
        editPatient: builder.mutation({
            query: ({ id, body }) => ({
                url: id !== undefined ? `/patients/${id}` : `/patients/`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Patient', id: arg.id }]
        }),
        viewPatient: builder.query({
            query: (id) => `/patients/${id}`,

            providesTags: (result, error, arg) => [{ type: 'Patient', id: arg }],
            invalidatesTags: ['PatientActivityHistory']
        }),
        viewPatientDetails: builder.query({
            query: (id) => `/patients/${id}?action=view`,

            providesTags: (result, error, arg) => [{ type: 'Patient', id: arg }],
            invalidatesTags: ['PatientActivityHistory']
        }),
        // export patient api call
        exportPatients: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `/providers/export-associated-patients?page_number=1&${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
        addNotes: builder.mutation({
            query: org => ({
                url: `/patients/add-notes`,
                method: 'POST',
                body: org
            }),
            invalidatesTags: ['Patient']
        }),
        // activity history
        patientActivityHistoryList: builder.query({
            query: (searchParams) => `patients/list-changes?${searchParams}`,
            providesTags: ['PatientActivityHistory']

        }),
        exportPatientActivityHistory: builder.mutation({
            query: ({ sort, columns, username, dateformat, params }) => {
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url: `patients/export-vital-changes?${queryParams}`,
                    method: 'POST',
                    body: { "columns": columns, "target_user_name": username, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        // filter organization list
        // for organization listing
        getOrganizations: builder.query({
            query: (searchParams) => `organizations?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [

                'OrganizationList',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'OrganizationList', id: _id }))
            ] : [],
            // invalidatesTags:['SelectedOrg']

        }),

        patientStatusChange: builder.mutation({
            query: ({ id, body }) => ({
                url: `/patients/update-monitoring-status/${id}`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: ['Patient']
        }),

        getMonitorAssociatedToPatientList: builder.query({
            query: (searchParams) => `patients/list-linked-monitor-users?patient_id=${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'AssociatedMonitorToPatient',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ patient_id }) => ({ type: 'AssociatedMonitorToPatient', id: patient_id }))
            ] : [],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),

        getProviderAssociatedToPatientList: builder.query({
            query: (searchParams) => `patients/list-linked-providers?patient_id=${searchParams}&action=view`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'AssociatedProviderToPatient',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ patient_id }) => ({ type: 'AssociatedProviderToPatient', id: patient_id }))
            ] : [],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),

        getObserversAssociatedToPatientList: builder.query({
            query: (searchParams) => `patients/list-linked-observers/${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'AssociatedObserverToPatient',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ patient_id }) => ({ type: 'AssociatedObserverToPatient', id: patient_id }))
            ] : [],
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),
        exportPatientNotes: builder.mutation({
            query: ({ dateformat, patientId, noteType, filter, start_date, end_date, user_id }) => {
                let queryString = `patients/export-note/${patientId}?note_type=${noteType}`;
                // Conditionally include filter, start_date, and end_date if they are present
                if (filter) queryString += `&filter=${filter}`;
                if (start_date) queryString += `&start_date=${start_date}`;
                if (end_date) queryString += `&end_date=${end_date}`;

                const body = {
                    "dateformat": dateformat,
                    "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone,
                };

                // Conditionally include user_id in the body if it's present
                if (user_id) {
                    body.user_id = user_id;
                }

                return {
                    url: queryString,
                    method: 'POST',
                    body: body
                };
            },
        }),
        listWellnessNotes: builder.query({
            query: ({ id, body }) => {
                const { start_date, end_date, monitor_list } = body;

                // Construct query parameters
                const queryParams = [];

                // Add filter parameter if any of the keys are present
                if (start_date || end_date || monitor_list) {
                    queryParams.push('filter=true');
                }

                // Add start_date and end_date if present
                if (start_date) {
                    queryParams.push(`start_date=${encodeURIComponent(start_date)}`);
                }
                if (end_date) {
                    queryParams.push(`end_date=${encodeURIComponent(end_date)}`);
                }

                // Construct URL with query parameters
                const url = `/patients/list-wellness-note?patient_id=${id}&type=wellness-note${queryParams.length > 0 ? `&${queryParams.join('&')}` : ''}`;
                // Construct body
                const requestBody = monitor_list ? { user_id: monitor_list } : undefined;

                return {
                    url,
                    method: 'POST',
                    body: requestBody
                };
            },
            providesTags: (result, error, arg) => [{ type: 'Patient', id: arg }],
            invalidatesTags: ['Patient']
        }),

        // get provider deatils(provider associated to the patient)
        getProviders: builder.query({
            query: (searchParams) => `patients/list-linked-providers?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [

                'Providers',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ patient_id }) => ({ type: 'Providers', id: patient_id }))
            ] : []

        }),
        providerPreferenceChange: builder.mutation({
            query: ({ body }) => ({
                url: `/patients/update_preference`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: ['Patient']
        }),
        updateMonitorPatientAlertPreferences: builder.mutation({
            query: ({ patient_id, body }) => ({
                url: `/providers/patients/${patient_id}/alerts`,
                method: 'PATCH',
                body: body
            }),
            invalidatesTags: ['Patient']
        }),
        // send provider alert api
        sendProviderAlert: builder.mutation({
            query: org => ({
                url: `/patients/send-alert`,
                method: 'POST',
                body: org
            }),
            // invalidatesTags:['Patient']
        }),
        // provider alert listing api
        getAlertProvider: builder.query({
            query: (searchParamsAlert) => `patients/list-provider-alert?${searchParamsAlert}`,
            providesTags: (result = [], error, arg) => {
                if (error === undefined && Array.isArray(result?.data)) {
                    const providerTags = result.data.map(({ patient_id }) => ({
                        type: 'Providers',
                        id: patient_id,
                    }));
                    return ['Providers', ...providerTags];
                } else {
                    return [];
                }
            },
        }),
        VitalReadingList: builder.query({
            query: (searchParams) => `providers/list-historical-readings?${searchParams}`,
            providesTags: ['PatientActivityHistory']

        }),
        exportDeviceVitalReadingList: builder.mutation({
            query: ({ columns, dateformat, params }) => {
                const queryParams = Object.entries(params)
                    .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                    .join('&');
                return {
                    url: `patients/historical-data?${queryParams}`,
                    method: 'POST',
                    body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
                };
            },
        }),
        getPatientWellnessDetails: builder.query({
            query: (patientId) => `patients/vital-data?patient_id=${patientId}`,
            // invalidatesTags: ['SelectedOrg','OrganizationList','AssociatedProviderOrg']
        }),
        transferFile: builder.mutation({
            query: org => ({
                url: `/transfer-file`,
                method: 'POST',
                body: org
            }),
        }),
        // transfer file activity history
        ActivityHistoryFileTransfer: builder.mutation({
            query: org => ({
                url: `users/record-activity`,
                method: 'POST',
                body: org
            }),
        }),
        // help guide
        getHelpGuideProvider: builder.query({
            query: (queryParams) => ({
                url: `users/help-guides?${queryParams}`,
                method: 'GET',
            }),
            providesTags: ['Patient'], // Optional: useful for cache invalidation
        }),
        getHelpGuideProviderLogin: builder.query({
            query: (queryParams) => ({
                url: `users/help-guide-login?${queryParams}`,
                method: 'GET',
            }),
            providesTags: ['Patient'], // Optional: useful for cache invalidation for patient details
        }),

    }),

    overrideExisting: false
})


export const {
    useGetAlertProviderQuery,
    useSendProviderAlertMutation,
    useAddPatientMutation,
    useLazyGetPatientSubdivisionsQuery,
    useLazyGetPatientQuery,
    useViewPatientQuery,
    useEditPatientMutation,
    useExportPatientsMutation,
    useGetOrganizationsQuery,
    useGetPatientsQuery,
    useGetProvidersQuery,
    // useLazyGetProviderAssociatedToPatientListQuery,
    useAddNotesMutation,
    usePatientActivityHistoryListQuery,
    useExportPatientActivityHistoryMutation,
    useProviderPreferenceChangeMutation,
    useUpdateMonitorPatientAlertPreferencesMutation,
    usePatientStatusChangeMutation,
    useGetMonitorAssociatedToPatientListQuery,
    useGetProviderAssociatedToPatientListQuery,
    useGetObserversAssociatedToPatientListQuery,
    useExportPatientNotesMutation,
    useListWellnessNotesQuery,
    useVitalReadingListQuery,
    useGetPatientWellnessDetailsQuery,
    useExportDeviceVitalReadingListMutation,
    useViewPatientDetailsQuery,
    useLazyViewPatientQuery,
    useLazyViewPatientDetailsQuery,
    useTransferFileMutation,
    useActivityHistoryFileTransferMutation,
    useGetHelpGuideProviderQuery,
    useGetHelpGuideProviderLoginQuery,

} = patientList